import React from 'react'
import { Line } from 'react-chartjs-2';


function LineChart(props) {

    let labels = []
    let values = []

    if (props.data) {
        props.data.forEach(element => {
            labels.push(element.Key)
            values.push(element.Value)
        });
    }

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'No. of shipments',
                data: values,
                fill: false,
                backgroundColor: '#122d76',
                borderColor: '#122d76',
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
            xAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ]
        },
    };

    return (
        <Line data={data} options={options} />
    )
}

export default LineChart
